import { useCallback, useEffect } from 'react';

import { useInvalidateDelegatedKeysQueries } from '#/api/queries/delegatedKeysQueries';
import { useActiveWindowInterval } from '#/components/hooks';
import { checkAndDisplayDelegatedExpiringNotification } from '#/reduxState/delegatedKey/authorizationUtils';
import { staticDispatch, useSelector } from '#/reduxState/store';

export default function DelegatedKeysBackgroundWorker() {
  const { invalidateDelegatedKeys } = useInvalidateDelegatedKeysQueries();

  const wallet = useSelector(state => state.wallet);
  const delegatedWallet = useSelector(
    state => state.delegatedKey.authorization
  );
  const delegatedEngine = useSelector(
    state => state.delegatedKey.settings.engine
  );
  const createdTime = useSelector(
    state => state.delegatedKey.authorization.createdTime
  );
  const lastRenewNoticeTime = useSelector(
    state => state.delegatedKey.authorization.lastRenewNoticeTime
  );

  const checkDelegatedNotExpiring = useCallback(() => {
    if (!createdTime || !wallet.walletType || !delegatedEngine) {
      return;
    }
    checkAndDisplayDelegatedExpiringNotification({
      createdTime,
      delegatedEngine,
      dispatch: staticDispatch,
      lastRenewNoticeTime: lastRenewNoticeTime,
      wallet,
      delegatedWallet: delegatedWallet,
    });
  }, [
    delegatedWallet,
    createdTime,
    delegatedEngine,
    lastRenewNoticeTime,
    wallet,
  ]);

  // TODO: Consider useQueryWalletDelegatedKeys (but slow poling)
  //  which would also invalidate if expired or closed on server

  useActiveWindowInterval(
    () => {
      checkDelegatedNotExpiring();
    },
    10 * 60 * 1000
  );

  useEffect(() => {
    // Start initial check with slight delay so app can load,
    // before throwing notifications on user
    setTimeout(() => {
      checkDelegatedNotExpiring();
    }, 5000);
  }, [checkDelegatedNotExpiring]);

  useEffect(() => {
    // On each delegated wallet change,
    // we want to invalidate delegated keys cache
    invalidateDelegatedKeys();
  }, [invalidateDelegatedKeys, delegatedWallet.walletAddress]);

  return null;
}
